import { useCallback, type ReactNode } from "react"
import { config, IConfig } from "../config/Config"
import { getBusinessUnit } from "../utils/business.utils"
import {
  AvatarConfigProvider,
  ExternalConfig
} from "@infinitaslearning/auth-client"
import type { IdpUser } from "@infinitaslearning/auth-first-party-core"
import { AuthProvider, WithAuth, useAuth } from "@infinitaslearning/auth-first-party-web"
export interface IIdentityProviderProps {
  children: ReactNode
}

function HandleLiberLogin(config: IConfig): boolean {
  if (!config.externalLogin.liber) return false

  const searchParams = new URLSearchParams(window.location.search)

  if (!searchParams.get("enableIdp")) {
    window.location.href = config.externalLogin.liber
    return true
  }

  return false
}


export function IdentityProvider({ children }: IIdentityProviderProps) {
  const businessUnit = getBusinessUnit()

  const isLiber = businessUnit === "Liber"

  const searchParams = new URLSearchParams(window.location.search)
  const enableIdp = searchParams.get("enableIdp")

  const overrideLogin = useCallback(async (): Promise<boolean> => {
    const businessUnit = getBusinessUnit()
    switch (businessUnit) {
      case "Liber": {
        return HandleLiberLogin(config)
      }
      case "Plantyn":
      case "Noordhoff":
      default: {
        return false
      }
    }
  }, [config])


  const env =config.environment === "development" ? "staging" : (config.environment as ExternalConfig["environment"])

  const handleLoginSuccess = useCallback((user: IdpUser) => {
    window.sessionStorage.setItem("user", JSON.stringify(user))
  }, [])

  return (
    <AuthProvider onLoginSuccess={handleLoginSuccess}>
      <WithAuth overrideLogin={overrideLogin}>
        {/* @ts-expect-error AvatarConfigProvider return type mismatch between @emotion/react JSX and React JSX */}
        <AvatarConfigProvider
          config={{
            businessUnit: getBusinessUnit(),
            environment: env,
            platform: "SEP"
          }}
        >
          {children}
        </AvatarConfigProvider>
      </WithAuth>
    </AuthProvider>
  )
}

export const useAuthenticatedUser = (): IdpUser => {
  const { user } = useAuth()
  if (!user) throw new Error("User not authenticated")
  return user
}

export const getAuthenticatedUser = (): IdpUser => {
  const stringifiedUser = window.sessionStorage.getItem("user")
  if (!stringifiedUser) throw new Error("User not authenticated")

  try {
    return JSON.parse(stringifiedUser)
  } catch (error) {
    throw new Error("User not authenticated")
  }
}